const semanticClassNames = {
  root: 'multi-state-box',
} as const;

export default semanticClassNames;
